import { getObjectUtil } from 'packages/src'
import REDUX_ACTION from '../../constants/action'

/**
 * Sets the `value` at the given `payload.path`.
 * @param {Object} action
 *        {string} action.path
 *        {String[]} [action.paths]
 *        {string} action.value
 *        {String[]} [action.values]
 *        {Object} [action.options]
 */
export default function setReduxAction (action) {
  return (dispatch, getState) => {
    const { payload } = action
    const {
      path,
      value
    } = payload
    if (path && getObjectUtil(getState(), path) === value) {
      return
    }
    return dispatch({
      type: action.type,
      reduxType: REDUX_ACTION.SET,
      payload
    })
  }
}
